module.exports = __webpack_public_path__ + "img/CustomerInfo.9a109b9e.svg";